export default __webpack_public_path__ + "static/media/RS-Tutorial.371df31b.mp4";